import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: 'Can I just walk in?',
    answer: 'No. We are strictly appointment-only and do not accept walk-ins. All services must be scheduled in advance through our online booking system or by calling us directly.'
  }, {
    question: 'What is mobile fingerprinting?',
    answer: 'We bring our certified fingerprinting equipment directly to your office, facility, or business location. Our mobile team handles everything on-site so your employees never have to leave the workplace.'
  }, {
    question: 'What is the minimum for mobile/group fingerprinting?',
    answer: 'For mobile fingerprinting at your location, we require a minimum of 5 people. If your company has 5 or more employees who need fingerprinting, we will come to your facility. For fewer than 5, appointments are available at our Columbia, MD office.'
  }, {
    question: 'Do you work with corporate clients?',
    answer: 'Yes. We already work with multiple companies across Maryland and are actively expanding our corporate partnerships. Whether you need one-time group fingerprinting or an ongoing arrangement, we can accommodate your organization.'
  }, {
    question: "I was just fingerprinted last year. Why can't you just use those?",
    answer: 'Applicant prints are different from criminal prints and are only used for comparison in the criminal database. A new background check must be conducted for each new application. Results are sent from CJIS to the requesting agency. By law, prints are destroyed 90 days after collection.'
  }, {
    question: 'How much does it cost?',
    answer: 'We charge a flat fee of $62.25 for all background checks and fingerprinting services, including all CJIS / government fees. Contact us for group pricing for 5 or more employees.'
  }, {
    question: 'How long does it take?',
    answer: 'Each individual takes about 10-15 minutes. For larger groups at your facility, we allocate appropriate time based on headcount. Contact us ahead of time so we can plan accordingly.'
  }, {
    question: 'How do I book an appointment?',
    answer: 'Visit our Book Appointment page, choose your service, pick a day and time, and complete the form. For group or corporate bookings, contact our team directly to arrange mobile service at your location.'
  }, {
    question: 'What do I need to bring?',
    answer: "Two valid government-issued photo IDs (passport, driver's license, permanent resident card, or military ID). Plus any fingerprint paperwork from your employer. Minors must be accompanied by a legal parent with documentation."
  }, {
    question: 'What are the hours of operation?',
    answer: 'Monday-Friday 7:00 AM - 7:00 PM, Saturdays 9:00 AM - 5:00 PM by appointment only. All visits must be scheduled in advance — no walk-ins.'
  }, {
    question: 'How long for results?',
    answer: 'Wait at least 7 days before checking status. Typically 5-10 days for mail, 72 hours for the requesting agency. Contact MD Department of Public Safety at 410-764-4501 for status.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 bg-[#E7ECF8]" aria-labelledby="faq-heading" data-id="element-22">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <h2 id="faq-heading" className="text-3xl md:text-4xl font-bold text-[#1E1F55] mb-4" data-id="element-25">
            Frequently Asked Questions
          </h2>
          <div className="w-24 h-1 bg-[#4AA6CF] mx-auto rounded-full" aria-hidden="true" data-id="element-26"></div>
        </div>

        <div className="space-y-4" role="list" data-id="element-27">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" role="listitem" data-id="element-28">
              <h3 data-id="element-29">
                <button id={`faq-button-${index}`} onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex justify-between items-center" aria-expanded={openIndex === index} aria-controls={`faq-panel-${index}`} data-id="element-30">
                  <span className="font-bold text-[#1E1F55] pr-8" data-id="element-31">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 text-[#4AA6CF] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-32" />
                </button>
              </h3>

              <AnimatePresence initial={false} data-id="element-33">
                {openIndex === index && <motion.div id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-button-${index}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-34">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-35">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}